import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  height: inherit;
`

export const Header = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.s300};
  display: flex;
  gap: ${({ theme }) => theme.space.s200};
  padding: ${({ theme }) => theme.space.s200};
`

export const Title = styled.div`
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.text.title};
  font-family: ${({ theme }) => theme.typography.heading.small.fontFamily};
  font-size: ${({ theme }) => theme.typography.heading.small.fontSize};
  font-weight: ${({ theme }) => theme.typography.heading.small.fontWeight};
  line-height: ${({ theme }) => theme.typography.heading.small.lineHeight};
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
  pointer-events: auto;
`

export const Content = styled.div`
  height: inherit;
  overflow: auto;
`
